import React, { useState } from 'react';

export const BrandLogoWithFallback = ({ brand, logo, logoDarkBg = false, size = 'default', testId }) => {
  const [hasError, setHasError] = useState(false);
  const logoSizeClass = size === 'compact' ? 'max-h-9 max-w-[130px]' : 'max-h-[50px] max-w-[180px] w-auto';
  const textSizeClass = size === 'compact' ? 'text-sm' : 'text-2xl tracking-wide';

  return (
    <div className={`${logoDarkBg ? 'bg-gray-800' : 'bg-gray-50'} border border-gray-100 min-h-[54px] flex items-center justify-center px-2`} data-testid={`${testId}-wrap`}>
      {hasError ? (
        <span className={`${textSizeClass} font-extrabold text-gray-700`} data-testid={`${testId}-fallback`}>
          {brand}
        </span>
      ) : (
        <img
          src={logo}
          alt={`${brand} logo`}
          className={`${logoSizeClass} object-contain`}
          onError={() => setHasError(true)}
          data-testid={testId}
        />
      )}
    </div>
  );
};